export enum FollowUpStudyArchiveReasonCode {
	InsufficientDocuments = "INSUFFICIENT_DOCUMENTS",
	Duplication = "DUPLICATION",
	SubmitterNonResponsive = "SUBMITTER_NON_RESPONSIVE",
	LackOfJurisdiction = "LACK_OF_JURISDICTION",
	PreviouslyDecided = "PREVIOUSLY_DECIDED",
	UnderConsiderationByOtherEntity = "UNDER_CONSIDERATION_BY_OTHER_ENTITY",
	ViolationNotProven = "VIOLATION_NOT_PROVEN",
}
